import AbstractNode from './AbstractNode';
import {
  liftListItem,
  sinkListItem,
  splitListItem,
} from 'prosemirror-schema-list';

export default class CheckBoxItem extends AbstractNode {
    get name() {
        return "checkbox_item";
    }

    get schema() {
        return {
            attrs: {
                checked: {
                    default: false,
                }
            },
            content: "block+",
            defining: true,
            draggable: false,
            parseDOM: [{
                tag: 'ul.task-list li',
                getAttrs: token => ({
                    checked: token.querySelector('input')?.checked,
                }),
            }],
            toDOM: node => {
                const input = document.createElement("input");
                input.type = "checkbox";
                input.className = 'task-list-item-checkbox';
                if (node.attrs.checked === true) {
                    input.checked = true;
                    input.setAttribute('checked', 'checked');
                }

                return [
                    "li", {
                        class: node.attrs.checked ? "task-list-item checked" : "task-list-item",
                    }, [
                        "span", {
                            contentEditable: false
                        },
                        input,
                    ],
                    ["div", 0]
                ];
            }
        }
    }

    toMarkdown(state, node) {
        state.write(node.attrs.checked ? "[x] " : "[ ] ");
        state.renderContent(node);
    }

    get parseMarkdown() {
        return {
            block: "checkbox_item", getAttrs: token => ({
                checked: token.attrGet("checked") ? true : undefined,
            })
        };
    }

    keys({type}) {
        return {
            Enter: splitListItem(type),
            Tab: sinkListItem(type),
            "Shift-Tab": liftListItem(type)
        };
    }
}